//theme colors and tints (dark900 to normal500 to light100)
const colors = {
  grey900: "#111010",
  grey800: "#3D3F42",
  grey700: "#7D7F81",
  grey600: "#A9AAAB",
  grey500: "#BEBFC0",
  grey400: "#D4D4D5",
  grey300: "#E9EAEA",
  grey200: "#F2F2F2",
  grey100: "#F9F9FA",

  orange600: "#FF6B00",
  orange500: "#FF8B66",

  red600: "#D32030",
};

export default colors;
